export default {
	title: "Stay informed with the latest insights, ideas and articles",
	sections: [
		{
			title: "ARTICLES",
			icon: "article",
			items: [
				// { text: "Browse Topics", link: "/articles/topics" },
				{ text: "Browse Articles", link: "/articles" },
				{ text: "Self-Management", link: "/articles/topics/self-management" },
				{ text: "Operations and Policy", link: "/articles/topics/operations-and-policy" },
				{ text: "Quality and Risk", link: "/articles/topics/quality-and-risk" },
				{ text: "Motivations and Thinking Style", link: "/articles/topics/motivations-and-thinking-style" },
				{ text: "Strategy and Innovation", link: "/articles/topics/strategy-and-innovation" },
				{ text: "Problem Solving", link: "/articles/topics/problem-solving" },
				{ text: "Finance", link: "/articles/topics/finance" },
				{ text: "Team Building and Teamwork", link: "/articles/topics/team-building-and-teamwork" },
				{ text: "Professional Capabilities", link: "/articles/topics/professional-capabilities" },
			],
		},
		
		{
			title: "WEBINARS",
			icon: "smile",
			items: [
				{ text: "Browse Webinars", link: "/webinars" },
				{ 	text: "Why Being a CMO is the Best Job in Medicine", 
					subText: "Wednesday June 25, 2025 \n" +
					 "Discover how CMOs act as a trusted bridge to foster a collaborative environment",
					link: "/webinar/why-being-a-cmo-is-the-best-job-in-medicine" },
				{ 	text: "Physician Leadership: Why Now, Why the HALM Not?", 
					subText: "Wednesday May 28, 2025 \n" +
					 "How AAPL is leading the charge for healthcare leadership",
					link: "/webinar/the-halm-credential-and-aapl" }
			],
		},

		//TODO remove these wellness pages, maybe add a redirect for older articles which link out to these.
		// {
		// 	title: "WELLNESS",
		// 	icon: "smile",
		// 	items: [
		// 		{ text: "Workplace Wellness", link: "/resources/wellness/workplace-wellness" },
		// 		{ text: "Burnout & Suicide Prevention", link: "/resources/wellness/burnout-suicide-prevention" },
		// 		{ text: "Diversity & Wellness", link: "/resources/wellness/diversity" },
		// 		{ text: "Practicing Mindfulness", link: "/resources/wellness/practicing-mindfulness" },
		// 		{ text: "Stress Reduction & Management", link: "/resources/wellness/stress-management" },
		// 		{ text: "Mindset", link: "/resources/wellness/mindset" },
		// 	],
		// },

		{
			title: "PUBLICATIONS",
			icon: "book",
			items: [
				{
					text: "Physician Leadership White Paper",
					link: "/whitepaper",
				},
				{
					text: "Physician Leadership Journal (PLJ)",
					link: "/publications/plj",
				},
				{
					text: "Healthcare Administration Leadership and Management Journal",
					link: "/publications/halmj",
				},
				{ text: "The Journal of Medical Practice Management", link: "/publications/jmpm" },
				// { text: "Healthcare Administration Leadership & Management Journal", link: "/publications/halmj" },
				{ text: "FAST Practice Newsletter", link: "/publications/fast-practice" },
				{
					text: "Contribute",
					link: "/publications/contribute",
				},
				{ text: "SoundPractice Podcast", link: "https://www.soundpractice.com/" },
				{ text: "Books", link: "/publications/books" },
			],
		},
	],

	side: {
		data: [
			{
				title: "AAPL'S PODCAST",
				subTitle: "SoundPractice",
				details: "The business podcast for physicians & health care leaders.",
				buttonText: "Listen Now",
				link: "https://www.soundpractice.com/",
			},
			{
				title: "CELEBRATING 50 YEARS",
				subTitle: "50 Notable Thought Leadership Resources",
				details: "Special collection featuring complimentary resources.",
				buttonText: "Explore",
				link: "/articles/50-resources",
			},
		],
	},
};
